<div class="container-fluid">
    <div class="messages-container">
        <div class="row">
            <div class="col-3 align-content-start">
                <div class="welldone-card">
                    <div class="welldone-card-body">
                        <button class="btn btn-primary w-100 mb-4" *ngIf="isAdmin || isCompany"
                                (click)="openNewMessageModal()">
                            Nuovo messaggio
                        </button>

                        <div class="messages-menu flex-column">
                            <div class="menu-type" [ngClass]="{'active': messagesMenuActive === 'AllMessages'}"
                                 (click)="navigateToCategory(0)">
                                <i class="bi bi-inbox-fill me-2"></i>
                                <span class="menu-label">Tutti</span>
                                <span class="messages-counter">{{ totalMessagesCount }}</span>
                            </div>
                            <div class="menu-type" [ngClass]="{'active': messagesMenuActive === 'UnreadReceivedMessages'}"
                                 (click)="navigateToCategory(1)">
                                <i class="bi bi-envelope-exclamation-fill me-2"></i>
                                <span class="menu-label">Da leggere</span>
                                <span class="messages-counter">{{ messagesToRead }}</span>
                            </div>

                            <div class="menu-type" [ngClass]="{'active': messagesMenuActive === 'ReceivedMessages'}"
                                 (click)="navigateToCategory(2)">
                                <i class="bi bi-envelope-fill me-2"></i>
                                <span class="menu-label">Ricevuti</span>
                                <span class="messages-counter">{{ messagesNoFilter.length }}</span>
                            </div>

                            <div class="menu-type" [ngClass]="{'active': messagesMenuActive === 'SentMessages'}"
                                 (click)="navigateToCategory(3)">
                                <i class="bi bi-send-fill me-2"></i>
                                <span class="menu-label">Inviati</span>
                                <span class="messages-counter">{{ messagesSent }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-9">
                <div class="welldone-card">
                    <div class="welldone-card-header" *ngIf="!messageId">
                        Comunicazioni
                    </div>
                    <div>
                        <ng-container *ngIf="messageId; else inbox">
                            <ui-message-details></ui-message-details>
                        </ng-container>
                        <ng-template #inbox>
                            <div *ngIf="loadingMessages; else inboxList" class="divide-y divide-slate-100" aria-busy="true" aria-label="Caricamento messaggi">
                                <div *ngFor="let row of [1, 2, 3, 4, 5, 6]" class="flex animate-pulse items-center gap-4 px-4 py-4">
                                    <span class="h-4 w-4 shrink-0 rounded-full bg-slate-200"></span>
                                    <span class="h-7 w-7 shrink-0 rounded-full bg-slate-200"></span>
                                    <span class="h-3 w-28 rounded bg-slate-200"></span>
                                    <span class="h-3 flex-1 rounded bg-slate-100"></span>
                                    <span class="h-3 w-20 rounded bg-slate-200"></span>
                                </div>
                            </div>
                            <ng-template #inboxList>
                                <div class="w-100">
                                    <ui-messages-inbox [messages]="paginatedMessages"></ui-messages-inbox>
                                </div>
                            </ng-template>
                        </ng-template>
                    </div>
                </div>

                <div *ngIf="!messageId && !loadingMessages">
                    <nav aria-label="Page navigation example" class="mt-4">
                        <ul class="pagination justify-content-center mb-0">
                            <li class="page-item" [ngClass]="{'disabled': currentPage === 0}">
                                <a class="page-link" href="javascript:void(0)" (click)="previousPagePagination()" aria-label="Previous">
                                    <span aria-hidden="true">&laquo;</span>
                                </a>
                            </li>
                            <li class="page-item" *ngFor="let page of getPagesArray()">
                                <a class="page-link" href="javascript:void(0)"
                                   (click)="page === -1 ? loadPageGroup('prev') : page === -2 ? loadPageGroup('next') : loadPage(page - 1)"
                                   [ngClass]="{'active': currentPage === page - 1}">
                                    {{ page === -1 || page === -2 ? '...' : page }}
                                </a>
                            </li>
                            <li class="page-item" [ngClass]="{'disabled': currentPage === pagesCount - 1}">
                                <a class="page-link" href="javascript:void(0)" (click)="nextPagePagination()" aria-label="Next">
                                    <span aria-hidden="true">&raquo;</span>
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    </div>
</div>

<ngx-smart-modal #newMessageModal identifier="newMessageModal" customClass="season-modal is-wide" [closable]="true"
                  (onClose)="closeNewMessageModal()">
    <form #newMessageForm="ngForm" class="w-full">
        <header class="flex items-start gap-3.5 pl-6 pr-14 pt-5">
            <span class="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-primary-soft text-lg text-primary">
                <i class="bi bi-send" aria-hidden="true"></i>
            </span>
            <div>
                <h2 class="m-0 text-[1.05rem] font-bold leading-6 text-slate-900">Nuovo messaggio</h2>
                <p class="m-0 mt-0.5 text-sm text-slate-500">I destinatari riceveranno anche una notifica via email.</p>
            </div>
        </header>

        <div class="flex flex-col gap-4 px-6 pb-6 pt-5">
            <div *ngIf="isAdmin">
                <label for="targetUserGroup" class="form-label required mb-1.5 block text-sm font-semibold text-slate-700">Destinatari</label>
                <select class="form-select form-select-solid" id="targetUserGroup" name="target-user-group"
                        [(ngModel)]="newMessage.targetUserGroup" required>
                    <option value="">Seleziona un gruppo di destinazione</option>
                    <option *ngFor="let target of messageTarget" [value]="target.value">{{ target.text }}</option>
                </select>
            </div>

            <div *ngIf="isCompany">
                <div class="grid grid-cols-3 gap-1 rounded-xl bg-slate-100 p-1" role="group" aria-label="Destinatari">
                    <button type="button" *ngFor="let type of recipientTypes"
                            class="rounded-lg border-0 px-3 py-2 text-sm font-semibold transition-colors"
                            [ngClass]="entityMessageType === type.value ? 'bg-white text-primary shadow-sm' : 'bg-transparent text-slate-500 hover:text-slate-800'"
                            [attr.aria-pressed]="entityMessageType === type.value"
                            (click)="setRecipientType(type.value)">
                        <i class="bi mr-1.5" [ngClass]="type.icon" aria-hidden="true"></i>{{ type.text }}
                    </button>
                </div>

                <div *ngIf="entityMessageType === '0'" class="mt-3 flex flex-col gap-3">
                    <div>
                        <span class="form-label required mb-1.5 block text-sm font-semibold text-slate-700">Categoria</span>
                        <welldone-multiselect [single]="true" placeholder="Seleziona una categoria"
                                              [settings]="categoryDropdownSettings" [data]="parentCategories"
                                              name="message-parent-category" [ngModel]="selectedParentCategory"
                                              (ngModelChange)="selectedParentCategory = $event; onParentCategoryChange()">
                        </welldone-multiselect>
                    </div>
                    <div *ngIf="subCategories.length">
                        <span class="form-label mb-1.5 block text-sm font-semibold text-slate-700">Sottocategoria</span>
                        <welldone-multiselect [single]="true" placeholder="Tutte le sottocategorie"
                                              [settings]="categoryDropdownSettings" [data]="subCategories"
                                              name="message-sub-category" [ngModel]="selectedSubCategory"
                                              (ngModelChange)="selectedSubCategory = $event; onSubCategoryChange()">
                        </welldone-multiselect>
                    </div>
                </div>

                <div *ngIf="entityMessageType === '1'" class="mt-3">
                    <welldone-multiselect [single]="true" [placeholder]="'Cerca il nome di un utente'"
                                          [settings]="usersDropdownSettings"
                                          [data]="users"
                                          (onSelect)="onUserSelect($event)" (onDeSelect)="newMessage.userId = undefined"
                                          (onFilterChange)="onFilterChange($event)">
                    </welldone-multiselect>
                </div>
            </div>

            <div>
                <label for="messageTitle" class="form-label required mb-1.5 block text-sm font-semibold text-slate-700">Titolo</label>
                <input type="text" class="form-control form-control-solid" id="messageTitle" name="message-title"
                       placeholder="Es. Allenamento annullato" [(ngModel)]="newMessage.title" required/>
            </div>

            <div>
                <span class="form-label required mb-1.5 block text-sm font-semibold text-slate-700">Messaggio</span>
                <jodit-editor [config]="wysiwygConfig" id="message-text" name="message-text"
                              [(ngModel)]="newMessage.text" required></jodit-editor>
            </div>
        </div>

        <footer class="flex justify-end gap-2.5 border-t border-slate-100 bg-slate-50/60 px-6 py-4">
            <button type="button" class="btn welldone-btn-gray" (click)="newMessageModal.close()">Annulla</button>
            <button type="button" class="btn btn-primary" (click)="sendMessage(newMessage)"
                    [disabled]="newMessageForm.invalid || !hasRecipient">
                <i class="bi bi-send mr-1.5" aria-hidden="true"></i>Invia messaggio
            </button>
        </footer>
    </form>
</ngx-smart-modal>
